// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"src-components-BudgetBuilder-shared-ExpandIcon-styles___expandIcon"};